import React, { useMemo } from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';
import { getValue } from '@/helpers/GetValueHelper';

import { isLayout } from '../utils';
import { Header } from '../Header';

type TProps = {
  data: TRecommendation;
};

export const Banner = React.memo(({ data }: TProps) => {
  const { banner } = data;

  const [image, title] = useMemo(() => {
    return [
      getValue(banner, 'image.image.url', '') as string,
      getValue(banner, 'title', '') as string,
    ];
  }, [banner]);

  return isLayout(data, '4') && image && title ? (
    <div
      className="vitrine-template1__banner"
      data-testid="banner-container"
      style={{
        backgroundImage: `url(${image})`,
      }}
      title={clearHtmlTags(title)}
    >
      <Header data={data} />
      <div
        className="vitrine-template1__banner--text"
        data-testid="banner-text"
      >
        {title}
      </div>
    </div>
  ) : (
    <></>
  );
});
